import React from "react";

export default function TopUsersPagination({
  currentPage,
  totalPages,
  total,
  startIndex,
  endIndex,
  onPrev,
  onNext,
}) {
  if (totalPages <= 1) return null;

  return (
    <div className="mt-4 sm:mt-6 flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4 px-3 sm:px-4 py-4 bg-gray-50 rounded-lg border border-gray-200 min-w-0">
      <p className="text-xs sm:text-sm font-medium text-gray-700 text-center sm:text-left order-2 sm:order-1">
        Page <span className="font-bold text-gray-900">{currentPage}</span> of{" "}
        <span className="font-bold text-gray-900">{totalPages}</span>
        {" "}(<span className="font-bold text-red-600">{total}</span> users)
      </p>
      <div className="flex gap-2 items-center justify-center flex-wrap order-1 sm:order-2">
        <button
          type="button"
          onClick={onPrev}
          disabled={currentPage === 1}
          className={`px-3 py-1.5 sm:px-4 sm:py-2 border rounded-lg font-medium text-xs sm:text-sm transition-colors ${
            currentPage === 1
              ? "bg-gray-100 text-gray-400 cursor-not-allowed border-gray-200"
              : "bg-white text-gray-700 hover:bg-gray-50 border-gray-300 hover:border-gray-400"
          }`}>
          Previous
        </button>
        <span className="text-xs sm:text-sm text-gray-600 px-1">
          <span className="font-bold text-gray-900">{startIndex}</span>
          {" – "}
          <span className="font-bold text-gray-900">{endIndex}</span>
        </span>
        <button
          type="button"
          onClick={onNext}
          disabled={currentPage === totalPages}
          className={`px-3 py-1.5 sm:px-4 sm:py-2 border rounded-lg font-medium text-xs sm:text-sm transition-colors ${
            currentPage === totalPages
              ? "bg-gray-100 text-gray-400 cursor-not-allowed border-gray-200"
              : "bg-white text-gray-700 hover:bg-gray-50 border-gray-300 hover:border-gray-400"
          }`}>
          Next
        </button>
      </div>
    </div>
  );
}
